export enum HeaderType {
    FIRST_PAGE = 1,
    ALL_PAGES = 2
}